import { z } from "zod";

export const placementAddressSchema = z
  .object({
    address: z.object({
      formatted: z.string(),
      city: z.string(),
      state: z.string(),
      stateCode: z.string(),
      country: z.string(),
      countryCode: z.string(),
      postalCode: z.string().optional(), // allow addresses without postal code i.e. streets
      line1: z.string().optional(),
      subpremise: z.string().optional(),
      streetNumber: z.string().optional(),
      streetName: z.string().optional(),
      region: z.string().optional(),
      metropolitanStatisticalArea: z.string().optional(),
      manualMsa: z.boolean().optional(),
      isApproximateMsa: z.boolean().optional(),
      combinedStatisticalArea: z.string().optional(),
      neighborhood: z.string().optional(),
    }),
    coordinates: z.object({
      latitude: z.number(),
      longitude: z.number(),
    }),
  })
  .nullish();

export type PlacementAddress = z.infer<typeof placementAddressSchema>;
